import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane, Table } from 'reactstrap';
import { getProductiveCycleList } from '../../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../../Components/OElements/OSelect';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup'; // Asegúrate de importar Yup
import CriticalityObligations from '../Widgets/Normative/CriticalityObligations';
import ComplianceObligations from '../Widgets/Normative/ComplianceObligations';
import ComplianceMatrixIObligations from '../Widgets/Normative/ComplianceMatrixIObligations';
import PDFReport from '../Widgets/Normative/ejemplopdf';
import CaptureBarChart from '../Widgets/Normative/CaptureBarChart';

const NormativeSection = ({ id }) => {

    const [selectedProductiveCycle, setSelectedProductiveCycle] = useState(null);

    // Handler para actualizar el ciclo productivo seleccionado
    const handleProductiveCycleSelect = (optionSelected) => {
        setSelectedProductiveCycle(optionSelected ? optionSelected._id : null);
        validation.setFieldValue('productive_cycle_id', optionSelected ? optionSelected._id : null);
    };

    // Formik para validación del formulario
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            productive_cycle_id: null
        },
        validationSchema: Yup.object({
            productive_cycle_id: Yup.string().nullable(),
        }),
        onSubmit: values => {
            // Manejo de la lógica del submit aquí si es necesario
        }
    });

    console.log(selectedProductiveCycle)

    return (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <Row>
                        <Col md={2}>
                            <OSelect
                                label='Ciclo Productivo'
                                id='productive_cycle_id'
                                name='productive_cycle_id'
                                value={validation.values._id || ''}
                                handleLabelOptions={(item) => `${item.code}`}
                                onSelect={handleProductiveCycleSelect}
                                requestApi={() => getProductiveCycleList({})}
                                disabled={false}
                                validation={validation}
                            />
                        </Col>
                        <Col md={2}>
                            <CriticalityObligations
                                establishment_id={'6682a81e66a9be3ecd710b1a'}
                                productive_cycle_id={selectedProductiveCycle} // Usa el valor actualizado
                                title={'Criticidad'}
                                legendPosition={'bottom'}
                                um={'Total'}
                            />
                        </Col>
                        <Col md={2}>
                            <ComplianceObligations
                                establishment_id={'6682a81e66a9be3ecd710b1a'}
                                productive_cycle_id={selectedProductiveCycle} // Usa el valor actualizado
                                title={'Cumplimiento'}
                                legendPosition={'bottom'}
                                um={'Total'}
                            />
                        </Col>
                        <Col md={4}>
                            <ComplianceMatrixIObligations
                                establishment_id={'6682a81e66a9be3ecd710b1a'}
                                productive_cycle_id={selectedProductiveCycle} // Usa el valor actualizado
                                title={'Matriz de Cumplimiento'}
                                legendPosition={'bottom'}
                                um={'Total'}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default NormativeSection;
